export const CCGLMinAge             = 20
export const DeafCampMinAge         = 8
export const DeafCampMaxAge         = 19
export const JuniorCampMinAge       = 7
export const JuniorCampMaxAge       = 12
export const YouthCampMinAge        = 11
export const YouthCampMaxAge        = 19
export const DayCampMinAge          = 6
export const DayCampMaxAge          = 12
